import React from "react";

/**
 * ShopModalMessage（プラン切り替え予約表示）
 *
 * props:
 * - pendingActive: boolean
 * - effectiveAtMs: number | null
 * - targetPlanName?: string
 * - className?: string
 */
const formatDateTimeJP = (ms) => {
  if (!ms || !Number.isFinite(Number(ms))) return "";
  try {
    const t = Number(ms);
    const d = new Date(t < 1e12 ? t * 1000 : t); // 秒混在保険
    const yy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    return `${yy}/${mm}/${dd} ${hh}:${mi}`;
  } catch {
    return "";
  }
};

export default function ShopModalMessage({
  pendingActive,
  effectiveAtMs,
  targetPlanName = "",
  className = "",
}) {
  const show = Boolean(pendingActive && effectiveAtMs);
  if (!show) return null;

  const when = formatDateTimeJP(effectiveAtMs);
  const target = String(targetPlanName || "").trim();

  return (
    <div className={`space-y-3 ${className}`}>
      <div className="rounded-3xl border border-gray-200 bg-white px-4 py-3">
        <div className="text-[11px] font-black text-gray-900">プラン切り替え／お支払い変更のお知らせ</div>

        {/* A案＋1行（アップ/ダウン両対応の中立文言） */}
        <div className="mt-1 text-[10px] font-bold text-gray-900/80 leading-relaxed whitespace-pre-line">
          {`次回支払日（${when || "反映日"}）より、${target ? `${target}` : "変更後"}プランの代金が適用されます。`}
        </div>
      </div>
    </div>
  );
}